import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Main from "./components/Main";
import Flotante from "./components/Flotante";
import Nordico from "./components/Nordico";
import Flores from './components/Flores';
import IlustDig from "./components/IlustracionDig";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop>
        <Switch>
          <Route exact path='/' component={Main} />
          <Route path='/flotante' component={Flotante} />
          <Route path='/nordico' component={Nordico} />
          <Route path='/ilust' component={IlustDig} />
          <Route path='/flowers' component={Flores} />
        </ Switch>
      </ScrollToTop>
    </Router>

  );
}

export default App;
